import {createReducer, on} from '@ngrx/store';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {
  clearDeleteManyStreamConfigurationsState,
  deleteManyStreamConfigurations,
  deleteManyStreamConfigurationsFailure,
  deleteManyStreamConfigurationsSuccess
} from './stream-configuration.delete-many.actions';


export interface State {
  record: StreamConfiguration[] | null;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyStreamConfigurationsReducer = createReducer(
  initialState,

  on(deleteManyStreamConfigurations, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyStreamConfigurationsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyStreamConfigurationsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyStreamConfigurationsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

